var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 160,
    viewBox: "0 0 224 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1141_33287)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M195.286 88.4357C187.894 100.418 189.279 116.742 192.526 129.613C193.612 133.922 194.864 138.472 193.935 143.294C192.799 149.192 188.657 153.823 184.465 156.475C176.824 161.298 168.097 161.164 161.743 156.121C156.256 151.766 152.642 144.169 147.039 140.047C137.671 133.148 124.807 137.329 113.638 143.778C105.739 148.329 97.0444 154.12 89.7434 150.841C84.607 148.539 81.404 142.042 79.9091 134.973C79.1875 131.56 78.751 127.831 77.0967 125.231C76.112 123.686 74.7587 122.651 73.3555 121.802C60.5493 114.066 43.2226 120.534 30.8728 111.773C22.5313 105.858 14.5277 98.0208 16.2309 80.5753C17.9341 63.1299 23.7671 61.8078 25.3717 48.0442C26.5137 38.2586 20.0146 22.0563 25.3716 11.5555C30.7287 1.05474 39.3438 -0.626446 46.7744 0.172371C54.205 0.971189 60.6569 5.68821 66.2179 11.4537C73.1681 18.659 79.4367 27.8614 88.4319 30.1859C94.5589 31.7696 101.25 29.9363 107.766 28.8998C118.645 27.1664 129.372 27.6637 140.023 28.3147C150.221 28.9378 160.479 29.7126 169.981 33.3073C176.704 35.8535 181.864 41.1537 188.139 44.6006C192.229 46.8473 196.843 47.1328 200.654 50.1284C205.348 53.8189 209.41 60.6309 207.53 69.2421C205.739 77.434 199.209 82.0771 195.286 88.4357Z",
    fill: "#2575FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142 14H4V126.5H142V14Z",
    fill: "#95A3B9",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_1141_33287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 27.25H14V44.25H39V27.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_1141_33287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 27.25H45V44.25H70V27.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ddd_1141_33287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101 27.25H76V44.25H101V27.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ddd_1141_33287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132 27.25H107V44.25H132V27.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ddd_1141_33287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 50.25H14V67.25H39V50.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ddd_1141_33287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 50.25H45V67.25H70V50.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ddd_1141_33287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101 50.25H76V67.25H101V50.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ddd_1141_33287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132 50.25H107V67.25H132V50.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_ddd_1141_33287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 73.25H14V90.25H39V73.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_ddd_1141_33287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 73.25H45V90.25H70V73.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_ddd_1141_33287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101 73.25H76V90.25H101V73.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_ddd_1141_33287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132 73.25H107V90.25H132V73.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_ddd_1141_33287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 96.25H14V113.25H39V96.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_ddd_1141_33287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 96.25H45V113.25H70V96.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_ddd_1141_33287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101 96.25H76V113.25H101V96.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_ddd_1141_33287)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132 96.25H107V113.25H132V96.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.61 59.2432C31.6087 60.6183 31.112 61.9469 30.2113 62.9846C29.3106 64.0224 28.0664 64.6996 26.7072 64.892C25.348 65.0843 23.9651 64.7789 22.8127 64.0317C21.6603 63.2845 20.8158 62.1457 20.4343 60.8247C20.0528 59.5037 20.1599 58.0892 20.7361 56.841C21.3122 55.5928 22.3187 54.5948 23.5704 54.0304C24.8222 53.466 26.2352 53.3731 27.5499 53.7688C28.8645 54.1645 29.9925 55.0221 30.7266 56.1842C31.3046 57.0993 31.611 58.1602 31.61 59.2432Z",
    fill: "#2575FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7266 56.1838L25.0998 61.8197C24.7461 61.2712 22.7759 58.7222 22.7759 58.7222C23.0284 58.4665 23.2978 58.2282 23.5824 58.009L25.2162 60.1913L30.0676 55.3311C30.3137 55.5938 30.5343 55.8793 30.7266 56.1838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0193 59.2431C63.018 60.6183 62.5214 61.9468 61.6207 62.9846C60.72 64.0223 59.4758 64.6996 58.1165 64.8919C56.7573 65.0843 55.3745 64.7788 54.2221 64.0316C53.0697 63.2844 52.2252 62.1457 51.8437 60.8247C51.4622 59.5037 51.5694 58.0892 52.1455 56.841C52.7217 55.5928 53.7281 54.5948 54.9798 54.0304C56.2316 53.466 57.6446 53.3731 58.9593 53.7688C60.2739 54.1645 61.4019 55.0221 62.1359 56.1842C62.714 57.0993 63.0204 58.1602 63.0193 59.2431Z",
    fill: "#2575FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.136 56.1838L56.5092 61.8197C56.1555 61.2712 54.1853 58.7222 54.1853 58.7222C54.4378 58.4665 54.7072 58.2282 54.9918 58.009L56.6256 60.1913L61.4771 55.3311C61.7231 55.5938 61.9437 55.8793 62.136 56.1838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.838 35.9458C125.836 37.3209 125.34 38.6495 124.439 39.6872C123.538 40.725 122.294 41.4022 120.935 41.5946C119.576 41.7869 118.193 41.4815 117.04 40.7343C115.888 39.9871 115.044 38.8484 114.662 37.5274C114.281 36.2064 114.388 34.7918 114.964 33.5436C115.54 32.2954 116.546 31.2975 117.798 30.7331C119.05 30.1687 120.463 30.0758 121.778 30.4714C123.092 30.8671 124.22 31.7248 124.954 32.8868C125.532 33.8019 125.839 34.8628 125.838 35.9458Z",
    fill: "#2575FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.954 32.8869L119.327 38.5228C118.974 37.9743 117.003 35.4253 117.003 35.4253C117.256 35.1696 117.525 34.9313 117.81 34.7121L119.444 36.8944L124.295 32.0342C124.541 32.2969 124.762 32.5824 124.954 32.8869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.977 98.3138C153.606 98.3138 154.116 97.8039 154.116 97.175C154.116 96.546 153.606 96.0361 152.977 96.0361C152.348 96.0361 151.838 96.546 151.838 97.175C151.838 97.8039 152.348 98.3138 152.977 98.3138Z",
    fill: "#2575FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.547 96.9867C154.176 96.9867 154.685 96.4768 154.685 95.8478C154.685 95.2189 154.176 94.709 153.547 94.709C152.918 94.709 152.408 95.2189 152.408 95.8478C152.408 96.4768 152.918 96.9867 153.547 96.9867Z",
    fill: "#2575FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.116 95.848C154.745 95.848 155.255 95.3381 155.255 94.7092C155.255 94.0802 154.745 93.5703 154.116 93.5703C153.487 93.5703 152.977 94.0802 152.977 94.7092C152.977 95.3381 153.487 95.848 154.116 95.848Z",
    fill: "#2575FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 148.5L174.144 150.809L171.946 153.007L164.705 154.691L159.485 154.185L159.822 152.333C159.922 151.935 160.13 151.572 160.422 151.284C160.715 150.996 161.081 150.794 161.481 150.701C163.626 150.197 167.718 149.047 168.577 147.45L173 148.5Z",
    fill: "#FBBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M173 148.5L174.144 150.809L171.946 153.007L164.705 154.691L159.485 154.185L159.822 152.333C159.922 151.935 160.13 151.572 160.422 151.284C160.715 150.996 161.081 150.794 161.481 150.701C163.626 150.197 167.718 149.047 168.577 147.45L173 148.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.177 153.671L162.188 152.325L161.177 150.764C161.177 150.764 158.146 151.987 156.799 151.819C155.452 151.651 154.779 154.017 157.305 154.682C159.83 155.348 174.144 154.682 174.144 154.682C174.144 154.682 176.669 153.503 174.144 150.305L171.946 151.989C171.946 151.989 168.241 154.009 166.389 153.673L161.177 153.671Z",
    fill: "#2E3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.629 156.53L161.85 157.036L169.091 155.351L171.289 153.154L171.111 152.618L170.859 151.867L170.607 151.136L165.724 149.789C165.475 150.196 165.132 150.539 164.725 150.788C163.139 151.873 160.29 152.656 158.617 153.048C158.55 153.064 158.483 153.085 158.418 153.11C158.063 153.229 157.745 153.435 157.491 153.709C157.238 153.984 157.058 154.318 156.967 154.68L156.629 156.53Z",
    fill: "#FBBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.314 156.03L159.325 154.683L158.314 153.123C158.314 153.123 155.283 154.345 153.936 154.178C152.59 154.01 151.916 156.375 154.442 157.041C156.967 157.706 171.281 157.041 171.281 157.041C171.281 157.041 173.806 155.862 171.281 152.663L169.083 154.347C169.083 154.347 165.379 156.367 163.527 156.032L158.314 156.03Z",
    fill: "#2E3037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.332 94.7549C176.332 94.7549 176.184 99.9636 174.5 103.5C174.5 103.5 174.142 112.216 174.142 117.804C174.142 122 174.342 123.914 175.5 128.5C176.658 133.086 173.563 139.487 173.46 146.598C173.445 147.651 173.46 149.294 173.46 149.294C173.46 149.294 168.066 151.314 166.555 148.956L168.072 128.916L167.399 101.132L176.332 94.7549Z",
    fill: "#474463"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M176.332 94.7549C176.332 94.7549 176.184 99.9636 174.5 103.5C174.5 103.5 174.142 112.216 174.142 117.804C174.142 122 174.342 123.914 175.5 128.5C176.658 133.086 173.563 139.487 173.46 146.598C173.445 147.651 173.46 149.294 173.46 149.294C173.46 149.294 168.066 151.314 166.555 148.956L168.072 128.916L167.399 101.132L176.332 94.7549Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.523 58.3615C162.523 58.3615 170.607 59.2026 169.428 55.836C169.099 54.8813 169.013 53.8593 169.179 52.863C169.388 51.6278 169.877 50.4566 170.607 49.4385L163.029 50.6173C163.483 51.3766 163.829 52.1957 164.056 53.0508C164.959 56.6212 162.523 58.3615 162.523 58.3615Z",
    fill: "#FBBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.7 73.5166L180.711 76.2119L181.552 81.9381C181.666 82.7358 181.588 83.549 181.324 84.3104C181.06 85.0718 180.619 85.7592 180.036 86.3156C178.016 88.3356 175.321 92.5453 175.321 92.5453L172.124 82.955C172.124 82.955 175.321 82.4496 174.819 80.2598C174.318 78.07 174.479 74.0141 174.479 74.0141L179.7 73.5166Z",
    fill: "#FC6681"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M179.7 73.5166L180.711 76.2119L181.552 81.9381C181.666 82.7358 181.588 83.549 181.324 84.3104C181.06 85.0718 180.619 85.7592 180.036 86.3156C178.016 88.3356 175.321 92.5453 175.321 92.5453L172.124 82.955C172.124 82.955 175.321 82.4496 174.819 80.2598C174.318 78.07 174.479 74.0141 174.479 74.0141L179.7 73.5166Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.5 102.5C159.385 108.972 161.415 115.056 163.029 121.335C165 129 165.5 134.5 165.5 141.5C165.5 148.5 164.548 150.304 164.548 150.304C166.905 154.513 170.941 151.65 170.941 151.65C170.941 151.65 170.923 150.009 170.941 148.957C171.063 142.057 173 136 173.299 131.445C173.597 126.889 172.12 120.835 172.12 120.835V106.85C174.817 104.162 176.458 100.593 176.741 96.7957C176.781 96.2443 176.813 95.6648 176.835 95.0635C176.971 91.2673 174.374 86.8098 173.359 85.2234C173.115 84.8398 172.959 84.624 172.959 84.624L158.09 90.5221L158.056 90.536V91.1115V92.3842C158.056 92.3842 158.09 99.5 158.5 102.5Z",
    fill: "#474463"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M163.029 50.6153C163.483 51.3746 163.829 52.1937 164.056 53.0488C164.879 53.3611 165.757 53.5054 166.636 53.4731C167.516 53.4409 168.381 53.2327 169.179 52.861C169.389 51.6264 169.877 50.456 170.607 49.4385L163.029 50.6153Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.398 53.1386C170.025 53.1386 172.965 50.1983 172.965 46.5713C172.965 42.9442 170.025 40.0039 166.398 40.0039C162.771 40.0039 159.83 42.9442 159.83 46.5713C159.83 50.1983 162.771 53.1386 166.398 53.1386Z",
    fill: "#FBBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M157.978 92.378L158.05 92.3919C165.111 93.8445 173.976 86.484 173.976 86.484C173.738 86.0834 173.533 85.6645 173.362 85.2312C173.119 84.8476 172.963 84.6318 172.963 84.6318L158.094 90.5298L158.056 91.1192L157.978 92.378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.83 58.1928C159.83 58.1928 169.261 52.4666 172.292 54.8243L176.501 60.2188C176.501 60.2188 179.197 61.0599 178.699 66.4485L180.711 76.2126C179.13 75.3366 178.309 74.6454 177 73L174.649 77.7291C174.649 77.7291 171.113 81.0977 173.976 85.9807C173.976 85.9807 165.051 93.3892 157.978 91.8748C157.978 91.8748 158.017 88.5392 158.5 85C158.984 81.4608 160 79.5832 157.305 75.5413C154.61 71.4994 157.137 67.6273 159.662 66.1108C159.662 66.1108 160.839 59.7093 159.83 58.1928Z",
    fill: "#FC6681"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.325 92.5449C159.325 92.5449 155.788 93.2182 154.104 95.9135C153.618 96.722 153.025 97.4612 152.342 98.1113C152.188 98.2507 152.069 98.4241 151.994 98.6176C151.919 98.8111 151.89 99.0195 151.909 99.2262C151.928 99.4329 151.996 99.6322 152.105 99.8084C152.215 99.9845 152.365 100.133 152.542 100.241C153.878 101.04 156.058 101.538 158.811 99.2761C163.534 95.408 159.325 92.5449 159.325 92.5449Z",
    fill: "#FBBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M164.546 61.393C164.546 61.393 167.914 61.0554 168.755 69.8125C169.596 78.5696 170.953 80.5896 170.953 80.5896C170.953 80.5896 171.794 85.137 169.774 87.8303C167.754 90.5235 163.88 96.2497 163.88 96.2497C163.88 96.2497 159.67 97.4286 158.829 93.2188L164.05 83.4527C164.05 83.4527 164.891 80.0841 162.871 77.7265C160.851 75.3689 159.325 59.7087 164.546 61.393Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.202 60.8872C164.202 60.8872 167.57 60.5495 168.412 69.3067C169.253 78.0638 170.609 80.0838 170.609 80.0838C170.609 80.0838 171.45 84.6312 169.431 87.3244C167.411 90.0177 163.536 95.7439 163.536 95.7439C163.536 95.7439 159.327 96.9227 158.486 92.713L163.706 82.9469C163.706 82.9469 164.258 81.9149 162.5 78C160.742 74.0851 158.987 59.2029 164.202 60.8872Z",
    fill: "#FC6681"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M161.429 67.2012C161.429 67.2012 161.093 72.4159 162.603 75.285C164.114 78.1541 164.12 81.8523 162.603 83.8763",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.122 37.7509C171.145 37.8768 172.32 38.2284 172.683 39.1895C172.819 39.5431 172.823 39.9327 172.917 40.2983C173.299 41.7689 174.955 42.4542 175.976 43.579C176.877 44.578 177.275 45.9147 177.574 47.2233C178.415 50.9761 178.618 54.8437 178.174 58.6638C177.846 61.4609 177.175 64.2061 176.987 67.0113C176.799 69.8165 177.143 72.7675 178.675 75.1251C179.334 76.1381 180.206 77.0292 180.673 78.144C179.708 78.9272 178.375 79.0391 177.131 79.0811C175.683 79.1304 174.234 79.1304 172.785 79.0811C172.026 79.0551 171.233 79.0052 170.577 78.6215C170.092 78.3112 169.693 77.883 169.418 77.3768C168.589 75.9782 168.382 74.2799 168.419 72.6496C168.457 71.0192 168.713 69.3969 168.743 67.7645C168.759 66.8754 168.689 65.9304 168.178 65.2031C167.808 64.6777 167.247 64.324 166.767 63.8984C164.969 62.3001 164.346 59.7387 164.286 57.3311C164.226 54.9235 164.623 52.512 164.42 50.1124C164.34 49.1734 163.988 48.0445 163.065 47.8627C162.773 47.8047 162.466 47.8627 162.186 47.7508C161.445 47.4651 161.516 46.4201 161.305 45.6549C161.067 44.7958 160.334 44.1325 160.128 43.2573C159.642 41.2194 162.236 38.7879 163.936 38.0786C165.664 37.3533 168.3 37.5252 170.122 37.7509Z",
    fill: "#472727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_1141_33287",
    x: -2,
    y: 19.25,
    width: 57,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.49281 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.494118 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1141_33287",
    result: "effect2_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.356863 0 0 0 0 0.733333 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1141_33287",
    result: "effect3_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1141_33287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_1141_33287",
    x: 29,
    y: 19.25,
    width: 57,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.49281 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.494118 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1141_33287",
    result: "effect2_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.356863 0 0 0 0 0.733333 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1141_33287",
    result: "effect3_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1141_33287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddd_1141_33287",
    x: 60,
    y: 19.25,
    width: 57,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.49281 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.494118 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1141_33287",
    result: "effect2_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.356863 0 0 0 0 0.733333 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1141_33287",
    result: "effect3_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1141_33287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ddd_1141_33287",
    x: 91,
    y: 19.25,
    width: 57,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.49281 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.494118 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1141_33287",
    result: "effect2_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.356863 0 0 0 0 0.733333 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1141_33287",
    result: "effect3_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1141_33287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ddd_1141_33287",
    x: -2,
    y: 42.25,
    width: 57,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.49281 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.494118 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1141_33287",
    result: "effect2_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.356863 0 0 0 0 0.733333 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1141_33287",
    result: "effect3_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1141_33287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ddd_1141_33287",
    x: 29,
    y: 42.25,
    width: 57,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.49281 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.494118 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1141_33287",
    result: "effect2_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.356863 0 0 0 0 0.733333 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1141_33287",
    result: "effect3_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1141_33287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ddd_1141_33287",
    x: 60,
    y: 42.25,
    width: 57,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.49281 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.494118 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1141_33287",
    result: "effect2_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.356863 0 0 0 0 0.733333 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1141_33287",
    result: "effect3_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1141_33287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ddd_1141_33287",
    x: 91,
    y: 42.25,
    width: 57,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.49281 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.494118 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1141_33287",
    result: "effect2_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.356863 0 0 0 0 0.733333 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1141_33287",
    result: "effect3_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1141_33287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ddd_1141_33287",
    x: -2,
    y: 65.25,
    width: 57,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.49281 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.494118 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1141_33287",
    result: "effect2_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.356863 0 0 0 0 0.733333 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1141_33287",
    result: "effect3_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1141_33287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_ddd_1141_33287",
    x: 29,
    y: 65.25,
    width: 57,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.49281 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.494118 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1141_33287",
    result: "effect2_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.356863 0 0 0 0 0.733333 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1141_33287",
    result: "effect3_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1141_33287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_ddd_1141_33287",
    x: 60,
    y: 65.25,
    width: 57,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.49281 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.494118 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1141_33287",
    result: "effect2_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.356863 0 0 0 0 0.733333 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1141_33287",
    result: "effect3_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1141_33287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_ddd_1141_33287",
    x: 91,
    y: 65.25,
    width: 57,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.49281 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.494118 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1141_33287",
    result: "effect2_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.356863 0 0 0 0 0.733333 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1141_33287",
    result: "effect3_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1141_33287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_ddd_1141_33287",
    x: -2,
    y: 88.25,
    width: 57,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.49281 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.494118 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1141_33287",
    result: "effect2_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.356863 0 0 0 0 0.733333 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1141_33287",
    result: "effect3_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1141_33287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_ddd_1141_33287",
    x: 29,
    y: 88.25,
    width: 57,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.49281 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.494118 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1141_33287",
    result: "effect2_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.356863 0 0 0 0 0.733333 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1141_33287",
    result: "effect3_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1141_33287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_ddd_1141_33287",
    x: 60,
    y: 88.25,
    width: 57,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.49281 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.494118 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1141_33287",
    result: "effect2_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.356863 0 0 0 0 0.733333 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1141_33287",
    result: "effect3_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1141_33287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_ddd_1141_33287",
    x: 91,
    y: 88.25,
    width: 57,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.49281 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.494118 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1141_33287",
    result: "effect2_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.356863 0 0 0 0 0.733333 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1141_33287",
    result: "effect3_dropShadow_1141_33287"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1141_33287",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1141_33287"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 160,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.170d7901.svg";
export { ForwardRef as ReactComponent };